"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.Container = void 0;
var _Utils = require("../Utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: center;\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    ", "\n    justify-content: center;\n    ", "\n    ", "\n    width: 100%;\n"])), (0, _Utils.parseProp)('height'), (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('height', 'max-height'));
const Item = exports.Item = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    align-items: center;\n    color: ", ";\n    ", "\n    display: inline-flex;\n    font-size: 13px;\n    font-weight: 500;\n    height: 100%;\n    justify-content: center;\n    padding: 0px 10px;\n    ", "\n"])), _ref => {
  let {
    theme: {
      primaryColor
    }
  } = _ref;
  return primaryColor;
}, _ref2 => {
  let {
    onClick
  } = _ref2;
  return !!onClick ? 'cursor: pointer;' : '';
}, _ref3 => {
  let {
    print
  } = _ref3;
  return !!print ? '' : '@media print { display: none; }';
});